@if (!!(confirmationData | async)) {
  <div class="row margin-top-30">
    <ds-confirmation [confirmationData]="confirmationData | async">
      <ds-confirmation-link-area>
        <a
          class="font-weight-semibold"
          href="javascript:void(0);"
          dsContent
          [contentPath]="'billing.backToBilling'"
          (click)="backToBilling()"
        >
        </a>
      </ds-confirmation-link-area>
    </ds-confirmation>
  </div>
}
